export const isUndefined = (x) => x === undefined;
